<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link v-if="ableToAddOrder" :to="{ name: 'EXSBOrderCreate' }" class="mb-1 btn btn-sm btn-primary float-right">{{ $t('buttons.create') }}</router-link>
    </template>
    <template #filtering>
      <div v-if="!isWholesaler">
        <b-button class="btn-sm float-right" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <OrdersFiltering></OrdersFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <Table v-else :items="items" :getPage="getPage"></Table>
      <pagination
        v-if="view"
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import OrdersFiltering from './components/OrdersFiltering/OrdersFiltering'
import Pagination from '../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import Table from './Table'
import { getUserRoles, checkPermission } from '@/utils/checkRoles'

export default {
  computed: {
    ...mapGetters({
      deletedItem: 'exsborder/del/deleted',
      error: 'exsborder/list/error',
      items: 'exsborder/list/items',
      isLoading: 'exsborder/list/isLoading',
      view: 'exsborder/list/view'
    }),
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    ableToAddOrder () {
      return checkPermission('orders', 'EXSBOrderCreate')
    }
  },

  components: {
    Loader,
    OrdersFiltering,
    Pagination,
    BaseTableWrapper,
    Table
  },

  methods: mapActions({
    getPage: 'exsborder/list/default'
  })
}
</script>
